import { render, staticRenderFns } from "./TeamShow.vue?vue&type=template&id=567c2e7c&scoped=true&"
import script from "./TeamShow.vue?vue&type=script&setup=true&lang=js&"
export * from "./TeamShow.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./TeamShow.vue?vue&type=style&index=0&id=567c2e7c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "567c2e7c",
  null
  
)

export default component.exports